import type { ContentfulOptions } from '~/services/origins/contentful';
import type { OptionSchema } from '~/shared/domain/models';

type AdaptOptions = (options: ContentfulOptions[]) => OptionSchema[];

export const adaptOptions: AdaptOptions = (options) => {
  if (!options) {
    throw new Error('Missing option');
  }

  return options.map((option) => {
    if (!option) {
      throw new Error('Missing valid option params');
    }

    return {
      label: option.fields.label,
      value: option.fields.value,
    };
  });
};
